module.exports = __webpack_public_path__ + "img/Ecommerce.70250eca.png";